import React from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faLinkedinIn,
  faSquareInstagram,
  faSquareWhatsapp,
  faVimeoV,
  faXTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelope,
  faGlobe,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

const SocialOption = ({ invalidURL, socialLinks, setInvalidURL }) => {
  const { getTextByKey } = useContent();
  const { setModal } = useModal();
  const { isSubscribed } = useUser();
  const listIcons = {
    website: faGlobe,
    youtube: faYoutube,
    twitter: faXTwitter,
    facebook: faFacebookF,
    instagram: faSquareInstagram,
    vimeo: faVimeoV,
    linkedin: faLinkedinIn,
    whatsapp: faSquareWhatsapp,
    phone: faPhone,
    email: faEnvelope,
  };

  //Social by click out input
  const handleChange = (state, setState, name) => {
    if (checkIfDisableInput(name.toLowerCase())) {
      setModal(() => <EmbedLimitOptionsModal />);
    } else {
      setState(state);
      setInvalidURL((prev) => prev.filter((item) => item !== name));
    }
  };
  const convertInvalidText = (text, linkType) => {
    let newText = text;
    if (text.includes("#linkType#")) {
      newText = text.replace("#linkType#", linkType);
    }
    return newText;
  };

  const firstLetterUpperCase = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  const checkIfDisableInput = (item) => {
    if (isSubscribed()) {
      return false;
    } else {
      if (item.toLowerCase() === "phone" || item.toLowerCase() === "email") {
        return false;
      } else {
        return true;
      }
    }
  };

  const showPopUp = (item) => {
    if (checkIfDisableInput(item)) {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  return (
    <div className="social-links">
      <div className="social-title">
        <span>{getTextByKey("personal-social-tooltip")}</span>
        <p>{getTextByKey("embed-page-social-desc")}</p>
      </div>
      <div className="links">
        {socialLinks.map((item, i) => (
          <div key={i} className="link-div">
            <div className="title">
              <span>
                {firstLetterUpperCase(
                  getTextByKey(
                    item.title.toLowerCase() === "email"
                      ? "signin-email-label"
                      : item.title.toLowerCase(),
                    true
                  )
                )}
              </span>
            </div>
            <div
              className={`input-div-link ${
                invalidURL.indexOf(item.name.toLowerCase()) !== -1
                  ? "invalid"
                  : ""
              } ${
                checkIfDisableInput(item.name.toLowerCase())
                  ? "disabled-input"
                  : ""
              }`}
            >
              <span className="social-icon">
                <FontAwesomeIcon
                  icon={listIcons[item?.name?.toLowerCase()]}
                  className="icon"
                />
              </span>
              <input
                disabled={checkIfDisableInput(item.name.toLowerCase())}
                value={item.state}
                type="text"
                onChange={(e) =>
                  handleChange(
                    e.target.value,
                    item.setState,
                    item.name.toLowerCase()
                  )
                }
              />
            </div>

            <div
              className={
                invalidURL.indexOf(item.name.toLowerCase()) !== -1
                  ? "invalid"
                  : "valid"
              }
            >
              <span>
                {convertInvalidText(
                  getTextByKey("invalid-social-link"),
                  item.name.toLowerCase()
                )}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocialOption;
